import { InteractionStatus } from '@azure/msal-browser';
import { withMsal, WithMsalProps } from '@azure/msal-react';
import React from 'react';
import './App.css';
import { login } from './azuread';
import LoadingBar from './LoadingBar';
import RosterNavigationAppBar from './RosterNavigationAppBar';

class App extends React.PureComponent<WithMsalProps> {
  componentDidMount() {
    this.callLogin();
  }

  componentDidUpdate() {
    this.callLogin();
  }

  callLogin() {
    const isAuthenticated = this.props.msalContext.accounts.length > 0;
    
    if (!isAuthenticated && this.props.msalContext.inProgress === InteractionStatus.None) {
      this.props.msalContext.instance.loginRedirect({ ...login });
    }
  }

  render() {
    const isAuthenticated = this.props.msalContext.accounts.length > 0;
    if (!isAuthenticated) {
      return <LoadingBar />
    }

    return <RosterNavigationAppBar selected={1} />
  }
}

export default withMsal(App);